<div class="backModal enCalendar" *ngIf="disableButtonEnter()">
  <div class="margin d-flex justify-content-center">
    <div class="lds-ring esperando">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <p class="waiting-p">{{ 'IMPRIMIENDOTICKETS' | translate }}</p>
  <!-- Agregar el texto debajo del spinner -->
</div>
<div class="close closeModal">
  <a (click)="close()" title="cerrar"
    ><span class="cross"></span><span class="sr-only">cerrar</span></a
  >
</div>
<div class="aviso">
  <div class="tituloSearch">{{ 'MENSAJE_DESEA_IMPRIMIR' | translateV2 }}</div>
  <div class="avisoInputWrap" [formGroup]="opcionesImpresionLocalizadorForm">
    <!-- <div class="onoffswitch-wrapGeneral">
      <div class="onoffswitch-wrap">
        <div class="onoffswitch">
          <input
            type="checkbox"
            formControlName="imprimirTodo"
            name="onoffswitch04"
            id="myonoffswitch04"
            class="onoffswitch-checkbox"
          />
          <label class="onoffswitch-label" for="myonoffswitch04"></label>
        </div>
        <label class="onoffswitch-label-text" for="myonoffswitch04">Imprimir Todo</label>
      </div>
    </div> -->
    <div class="checkboxStyledWrap">
      <div
        class="checkboxStyled"
        [ngClass]="{
          checked: opcionesImpresionLocalizadorForm.controls.entradas.value
        }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled42">
            <input
              formControlName="entradas"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled42"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled42">{{
          'ENTRADAS' | translateV2
        }}</label>
      </div>
      <!-- <div
        class="checkboxStyled"
        [ngClass]="{ checked: opcionesImpresionLocalizadorForm.controls.etiquetas.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled43">
            <input
              formControlName="etiquetas"
              class="label__checkbox"
              type="checkbox"
              id="myCheckboxStyled43"
            />
            <span class="label__check">
              <img class="svg" src="assets/img/checkbox-mark.svg" alt="icono checkbox" />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled43">ETIQUETAS</label>
      </div> -->
    </div>
  </div>
  <div class="faturacion-fila">
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="cancelar"
          class="cancelar"
          (click)="close()"
        >
          {{ 'CANCELAR' | translateV2 }}
        </button>
      </div>
    </div>
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="ACEPTAR"
          class="pagar aceptar"
          (click)="getOpcionesImpresion()"
        >
          {{ 'ACEPTAR' | translateV2 }}
        </button>
      </div>
    </div>
  </div>

  <div class="wrap-factura">
    <div *ngIf="showEnvioMail"
      [ngClass]="{ 'checkboxStyled': true, 'checked': true }">
        <div class="center">
          <label class="label" for="myCheckboxStyledGes02">
            <input
              class="label__checkbox w-100"
              type="checkbox"
              [(ngModel)]="enviarMail"
              id="myCheckboxStyledGes02"
              (change)="sendMailModal()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyledGes02">{{
          'OPCIONES_PAGO_ENVIO_MAIL' | translate
        }}</label>
    </div>
  </div>

</div>
